<ng-container *ngIf="flightState$ | async as flightState">
  <div class="flight-selector card-bg box-shadow">
    <div
      class="nav-button-container"
      *ngIf="{
        flightUrlList: flightUrlList$ | async,
        currentFlightUrlIndex: currentFlightUrlIndex$ | async
      } as vm"
    >
      <button
        mat-icon-button
        (click)="onPrevFlightClick()"
        [disabled]="vm.currentFlightUrlIndex === 0"
        color="primary"
      >
        <mat-icon>arrow_back_ios</mat-icon>
      </button>
      <div *ngIf="vm.currentFlightUrlIndex !== null">
        <div class="text-center text-sm">
          Flight {{ vm.currentFlightUrlIndex + 1 }} of
          {{ vm.flightUrlList?.length }}
        </div>
        <div class="text-center opacity-4 text-xs">
          {{ flightState.response?.depTimeSched?.weekdayLong }}
          {{ flightState.response?.depTimeSched?.toFormat("MM/dd/yyyy") }}
        </div>
      </div>
      <button
        mat-icon-button
        (click)="onNextFlightClick()"
        [disabled]="
          vm.currentFlightUrlIndex === (vm.flightUrlList?.length || 0) - 1
        "
        color="primary"
      >
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
    </div>
  </div>

  <mat-card
    *ngIf="flightState.response || flightState.isLoading"
    class="box-shadow border-radius-0"
    @fadeIn
  >
    <mat-card-content>
      <div class="leg-summary-container">
        <app-leg-summary
          [leg]="flightState.response"
          [isLoading]="flightState.isLoading"
          [isFlightDetailView]="true"
          (refreshFlight)="refreshFlight()"
        >
        </app-leg-summary>
      </div>
    </mat-card-content>
    <mat-progress-bar
      *ngIf="flightState.isLoading"
      class="progress-bar-bottom"
      color="accent"
      mode="indeterminate"
    ></mat-progress-bar>
  </mat-card>

  <button
    mat-stroked-button
    color="primary"
    class="save-button"
    (click)="onSaveAllClicked()"
    onclick="this.blur()"
    [disabled]="(connectionStatus$ | async) === 'offline'"
  >
    <mat-icon>save_alt</mat-icon>
    <span class="text-sm">Save All For Offline</span>
  </button>

  <app-flight-info-card></app-flight-info-card>

  <app-kcm-card
    *ngIf="flightState.response && flightState.response.isDpStart"
    @fadeIn
    [depAirport]="flightState.response.depStation"
  ></app-kcm-card>

  <app-crew-card
    *ngIf="flightState.response"
    [leg]="flightState.response"
    @fadeIn
  ></app-crew-card>

  <!-- <app-release-card *ngIf="flightState.response" @fadeIn></app-release-card> -->

  <app-armed-pax-card *ngIf="flightState.response"></app-armed-pax-card>

  <app-weather-card
    *ngIf="flightState.response"
    [flightState]="flightState.response"
    @fadeIn
  ></app-weather-card>

  <app-inbound-flight-card
    *ngIf="flightState.response"
    [flightState]="flightState.response"
    @fadeIn
  ></app-inbound-flight-card>

  <app-aircraft-card
    *ngIf="flightState.response"
    [flightState]="flightState.response"
    @fadeIn
  ></app-aircraft-card>

  <app-standby-list-card
    *ngIf="flightState.response"
    [flightState]="flightState.response"
    @fadeIn
  >
  </app-standby-list-card>

  <app-pax-connections
    *ngIf="flightState.response"
    [flightState]="flightState.response"
    @fadeIn
  ></app-pax-connections>

  <app-hotel-card
    *ngIf="
      flightState.response && flightState.response!.odlActual.as('minutes') > 0
    "
    [dutyPeriodIndex]="flightState.response.dutyPeriodIndex"
    @fadeIn
  ></app-hotel-card>

  <div *ngIf="flightState.isCompleteWithNoResponse()" class="flex-center mt-32">
    <h3>Unable to load flight information.</h3>
  </div>
</ng-container>
